import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Link from "next/link";
import Image from "next/legacy/image";
import { withTranslation } from 'next-i18next';
// styles
import styles from "./ConnectWallet.module.scss";
import { chainId as LocalChainID, chainIdHEX as LocalHexChainID } from "../../config/ethereum-config";

//Svg
import Metamask from "../../public/Metamask.svg"
import Back from "./svg/back";
import Next from "./svg/next";

// Images
import bgContent from "../../public/NFTapp/testimonial-img.png";
import { withRouter } from 'next/router';

// API helper
import { apiHelperBlockchain } from '../../helper/apiHelper';

//wallet
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { useAccount, useConnect, useSignMessage, useDisconnect, useNetwork, useSwitchNetwork } from 'wagmi';
import { useAuthRequestChallengeEvm } from '@moralisweb3/next';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { firebaseCloudMessaging } from '../../helper/firebaseHelper';
import axios from 'axios';
import {  moralisAuthUrl } from '../../env_development';

const CommonIndex = (props) => {
  // const { switchNetwork } = useChain();
  const { chain } = useNetwork()
  const [walletList, setWalletList] = useState([{ id: 1, title: props.t('common:metamask_wallet'), className: styles.meta }, { id: 2, title: props.t('common:wallet_connect'), className: styles.wallet }]);
  const [formError, setFormError] = useState("");
  const [link_id, setLink_id] = useState(0);
  const [networkChangeModal, setNetworkChangeModal] = useState(false);
  const [selectedChainID, setSelectedChainID] = useState(LocalChainID[0]);
  const [chainId, setChainId] = useState(LocalChainID[0])
  const [isConnectorPresent, setIsConnectorPresent] = useState(true)
  const [switchWithoutSign,setSwitchWithoutSign] = useState(null)
  const [switchWithoutConnect,setSwitchWithoutConnect] = useState(false)
  // const { isWeb3Enabled, enableWeb3, isWeb3EnableLoading, authenticate, isAuthenticated, isUserUpdating, user, account, isAuthenticating } = useMoralis();

  const { connectAsync } = useConnect();
  const walletConnectWagmi = useConnect({
    connector: new WalletConnectConnector({ options: { qrcode: true } }),
  });
  const { connect } =
  useConnect()
  const { disconnectAsync } = useDisconnect();
  const { isConnected, address } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const { requestChallengeAsync } = useAuthRequestChallengeEvm();

  const getRequestMessageForSignIn = async(address, chainId, domain) =>{
    try {
      const payload = {
        address, chainId, domain, uri : process.env.domainUrl, timeout : 15
      }

      const apiKEy = process.env.NEXT_PUBLIC_x_api_key

      const {data} = await axios({
        url : moralisAuthUrl,
        method : "POST",
        data : payload,
        headers :{
          "X-API-Key" : apiKEy
        }
      })

      return data


    } catch (error) {
      console.log(error,"error here");
      return error
    }

  }

  const {  switchNetwork } =
  useSwitchNetwork();

  useEffect(() => {
    detectBrowser();
  }, [address, chain, isConnected])

  const detectBrowser = () => {
    if (!window.ethereum) 
    {
      setIsConnectorPresent(false)
      if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          setWalletList([{ id: 2, title: props.t('common:wallet_connect'), className: styles.wallet }]);
        }
      }
      else {
        setWalletList([{ id: 1, title: props.t('common:metamask_wallet'), className: styles.meta }, { id: 2, title: props.t('common:wallet_connect'), className: styles.wallet }]);
      }
    }
  }

  useEffect(() => {
    const walletConnection = async () => {
      const wallet_address_check = localStorage.getItem("walletAddress");
      const userdata = localStorage.getItem("userData")

      if (parseInt(chainId) === parseInt(selectedChainID)) {
        setNetworkChangeModal(false);
        if (wallet_address_check && userdata) {

          if (parseInt(chainId) === parseInt(LocalChainID[1])) {
            localStorage.setItem("chainIndex", 2);
            localStorage.setItem("chainType", "polygon");
          } else if (parseInt(chainId) === parseInt(LocalChainID[0])) {
            localStorage.setItem("chainIndex", 1);
            localStorage.setItem("chainType", "ethereum")
          }
          window.location = "/" + props.currLocale + "/nft";
        }
      }
      // if (isAuthenticated && account) {
        if (isConnected && address) {

        if (address && (parseInt(chainId) != parseInt(selectedChainID))) {
          setNetworkChangeModal(true);
          if (selectedChainID === parseInt(LocalChainID[1])) {
            // switchNetwork(LocalHexChainID[1]);
            switchNetwork?.(parseInt(LocalHexChainID[1]))
          } else {
            switchNetwork?.(parseInt(LocalHexChainID[0]));
          }
        } else {
          setNetworkChangeModal(false);
        }
        // if (!isAuthenticating && account && !wallet_address_check) {
        //   localStorage.setItem("walletAddress", account);
        //   await initialiseUser(account);
        // }
      }
    }
    walletConnection();

  }, [chain, address, isConnected]);

  // useEffect(()=>{

  //   const walletConnection = async () => {
  //     const wallet_address_check = localStorage.getItem("walletAddress")
  //     if(isAuthenticated && account){
  //       if(account && (chainId != LocalChainID)){
  //         setNetworkChangeModal(true);
  //       }else{
  //         setNetworkChangeModal(false);
  //       }
  //       if(wallet_address_check){
  //         window.location = "/" + props.currLocale + "/nft";
  //       }
  //       if(!isAuthenticating && account && !wallet_address_check){
  //           localStorage.setItem("walletAddress", account);
  //           await initialiseUser(account);
  //           window.location = "/" + props.currLocale + "/nft";
  //       }
  //     }
  //   }
  //   walletConnection();

  // },[isAuthenticated,isAuthenticating,isUserUpdating,user,isWeb3Enabled,chainId,account]);

  const mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  const connectWallet = async (wallet_id) => {
    if (!isConnectorPresent && wallet_id !== 2 && !mobileAndTabletCheck()) {
      window.open("https://metamask.io/download/", "_blank", "noopener");
      return null;
    }
  
    try {
      setLink_id(wallet_id);
      let account, chain;
  
      if (wallet_id === 1) {
        ({ account, chain } = await connectToMetaMask());
        localStorage.setItem("connectorID", "injected");
      } else {
        ({ account, chain } = await connectToWalletConnect());
        localStorage.setItem("connectorID", "walletconnect");
      }
  
      setChainId(chain.id);
      const domain = process.env.domain;
      const messageData = await getRequestMessageForSignIn(account, chain.id, domain);
  
      if (!messageData.message) {
        const { message } = await requestChallengeAsync({
          address: account,
          chainId: chain.id,
          domain: "upyo.com",
        });
        messageData.message = message;
      }
  
      const signature = await signMessageAsync({ message: messageData.message });
  
      localStorage.setItem("walletAddress", account);
      await initialiseUser(account, chain.id, messageData.message, signature);
    } catch (error) {
      setSwitchWithoutConnect(true);
      // toast.error("Unable to connect to wallet")
    }
  };
  
  const connectToMetaMask = async () => {
    if (isConnected) {
      await firebaseCloudMessaging.delToken();
      await disconnectAsync();
    }
  
    const { account, chain } = await connectAsync({
      connector: new MetaMaskConnector({
        options: {
          shimChainChangedDisconnect: false,
        },
      }),
      chainId: parseInt(selectedChainID),
    });
  
    if (account) {
      setSwitchWithoutSign(account);
    }
  
    return { account, chain };
  };
  
  const connectToWalletConnect = async () => {
    if (isConnected) {
      await firebaseCloudMessaging.delToken();
      await disconnectAsync();
    }
  
    const { account, chain } = await walletConnectWagmi.connectAsync();
    return { account, chain };
  };
  

  useEffect(() => {
    const callAsync = async () => {
      if (switchWithoutSign && switchWithoutConnect) {
        try {
          connect({ connector: new MetaMaskConnector });
          const domain = process.env.domain;
          let messageData = await getRequestMessageForSignIn(switchWithoutSign, chainId, domain);
          if (!messageData.message) {
            const { message } = await requestChallengeAsync({ address: switchWithoutSign, chainId: chainId, domain: "upyo.com" });
            messageData.message = message;
          }
          const signature = await signMessageAsync({ message: messageData.message });
  
          localStorage.setItem("connectorID", "injected");
          localStorage.setItem("walletAddress", switchWithoutSign);
          await initialiseUser(switchWithoutSign, chainId, messageData.message, signature);
          setSwitchWithoutSign(null);
        } catch (error) {
          // Handle the error
          return true;
        }
      }
    };
  
    // Await the execution of callAsync
    callAsync().catch((error) => {
      // Handle any uncaught errors
      console.error(error);
    });
  }, [switchWithoutSign, switchWithoutConnect]);
  

  //initialiseUser
  const initialiseUser = async (walletAddress, chainId, message, signature) => {

    let wData = { wallet_address: walletAddress, message, signature };

    // initialise-user with UPYO
    await apiHelperBlockchain('initialise-user', 'POST', wData).then(res => {

      if (res.data.status === true) {
        localStorage.setItem("accessToken", res?.data?.data?.accessToken);
        localStorage.setItem("userData", JSON.stringify(res?.data?.data?.[0]));
        if (parseInt(chainId) === LocalChainID[1]) {
          localStorage.setItem("chainIndex", 2);
          localStorage.setItem("chainType", "polygon");
        } else if (parseInt(chainId) === LocalChainID[0]) {
          localStorage.setItem("chainIndex", 1);
          localStorage.setItem("chainType", "ethereum")
        }
        // window.location = "/" + props.currLocale + "/nft";
        const wallet_address_check = localStorage.getItem("walletAddress")
        if (parseInt(chainId) === parseInt(selectedChainID)) {
          setNetworkChangeModal(false);
          if (wallet_address_check) {
            window.location = "/" + props.currLocale + "/nft";
          }
        }
      }
    }).catch(error => console.error(`Error: ${error}`));
  }

  var content = props ? props.meta : null;
  const { t } = props;

  // console.log("======>",connect, connectors, error, isLoading, pendingConnector)

  return (
    <>
      <section className="section_pt80">
        <Container>
          <div className={styles.wallet}>
            <div className={` ${styles.wallet__head}`}>
              <div className='d-flex align-items-center'>
                <Link href={`/nft`}
                      className={`back ${styles.wallet__back}`}>
                    <Back />
                </Link>
                <div className={`ms-sm-4 ${styles.title}`}>
                  <h1 className={`h2 mb-2 ${styles.h2}`}>{content && content.pageHeading && content.pageHeading !== '' ? content.pageHeading : t('common:connect_wallet')}</h1>
                  <p>{t('common:termLine')}  <br />  {t('common:termLine2')}

                    <Link href={'/nft/terms'} >
                       {t('common:terms_service')}
                    </Link>
                    {t('common:and_our')}
                    <Link href={'/nft/privacy'}>
                      {t('common:privacy_policy')}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.wallet__body}>
              <div className={styles.wallet__wrapper}>
                {formError && <p className='alert alert-danger'>{formError}</p>}
                <div className={styles.wallet__bg}>
                  <Image src={bgContent} alt="Connect wallet" height={512} width={416} />
                </div>
              </div>
              <div className={styles.wallet__menu}>

                {/* <Button onClick={() => setSelectedChainID(5)}>Ethereum</Button>
                <Button onClick={() => setSelectedChainID(80001)}>Polygon</Button> */}

                <div className='customBTab'>
                  <Tabs activeKey={selectedChainID} transition={true} onSelect={(k) => setSelectedChainID(k)}>
                    <Tab eventKey={LocalChainID[0]} title={t('common:ethereum')}>
                      {walletList && walletList.map((wat, idx) => {
                        return (
                          <div key={idx} id={"Id" + wat.id} className={styles.wallet__link + " " + (link_id === wat.id ? styles.wallet__link_active : null)} onClick={() => connectWallet(wat.id)}>
                            <div className={`${styles.wallet__icon} ${wat.className}`}>
                              {wat.className === styles.meta ?
                                <Image src={Metamask} alt={t('common:connect_wallet')} />
                                :
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5ZM5 3C2.79086 3 1 4.79086 1 7V17C1 19.2091 2.79086 21 5 21H19C21.2091 21 23 19.2091 23 17V7C23 4.79086 21.2091 3 19 3H5Z" fill="#FCFCFD" />
                                  <path fillRule="evenodd" clipRule="evenodd" d="M13 12C13 9.23858 15.2386 7 18 7H22C22.5523 7 23 7.44772 23 8C23 8.55228 22.5523 9 22 9H18C16.3431 9 15 10.3431 15 12C15 13.6569 16.3431 15 18 15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H18C15.2386 17 13 14.7614 13 12Z" fill="#FCFCFD" />
                                  <path d="M19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12Z" fill="#FCFCFD" />
                                </svg>
                              }
                            </div>
                            <span>
                              {wat.title}
                            </span>
                            <div className={styles.wallet__arrow}>
                              <Next />
                            </div>
                          </div>
                        )
                      })}
                    </Tab>
                    <Tab eventKey={LocalChainID[1]} title={t('common:polygon')}>
                      {walletList && walletList.map((wat, idx) => {
                        return (
                          <div key={idx} id={"Id" + wat.id} className={styles.wallet__link + " " + (link_id === wat.id ? styles.wallet__link_active : null)} onClick={() => connectWallet(wat.id)}>
                            <div className={`${styles.wallet__icon} ${wat.className}`}>
                              {wat.className === styles.meta ?
                                <Image src={Metamask} alt={t('common:connect_wallet')} />
                                :
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5ZM5 3C2.79086 3 1 4.79086 1 7V17C1 19.2091 2.79086 21 5 21H19C21.2091 21 23 19.2091 23 17V7C23 4.79086 21.2091 3 19 3H5Z" fill="#FCFCFD" />
                                  <path fillRule="evenodd" clipRule="evenodd" d="M13 12C13 9.23858 15.2386 7 18 7H22C22.5523 7 23 7.44772 23 8C23 8.55228 22.5523 9 22 9H18C16.3431 9 15 10.3431 15 12C15 13.6569 16.3431 15 18 15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H18C15.2386 17 13 14.7614 13 12Z" fill="#FCFCFD" />
                                  <path d="M19 12C19 12.5523 18.5523 13 18 13C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12Z" fill="#FCFCFD" />
                                </svg>
                              }
                            </div>
                            <span>
                              {wat.title}
                            </span>
                            <div className={styles.wallet__arrow}>
                              <Next />
                            </div>
                          </div>
                        )
                      })}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Network change */}
      {/* {(networkChangeModal === true) ?
      <>
        <NetworkModal networkChangeModal={networkChangeModal} chainID={chainId}
        /></>
        : null} */}

    </>

  )
}


export default withTranslation()(withRouter(CommonIndex));
